import { TenantIds } from '@config/tenant-id';
import { SDate } from '@summit/core';
import { IUserExperience, SummitIdObject } from '@summit/models';
import { Dayjs } from 'dayjs';

export class ReportConfig extends SummitIdObject {
  override id: never;
  begin: Dayjs;
  end: Dayjs;
  includeLegEstimate: boolean;
  includeSpotEstimate: boolean;
  includeExtraItems: boolean;
  integrateExtraItems: boolean;
  onlyRejected: boolean;
  includeExtraAmounts: boolean;
  includeDailyTotals: boolean;
  includeTotals: boolean;
  testRun: boolean;
  message: string;

  constructor(jsonData?: Partial<ReportConfig>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.begin) this.begin = SDate.newUtc(jsonData.begin);
      if (jsonData.end) this.end = SDate.newUtc(jsonData.end);
    }
    this.includeLegEstimate ??= false;
    this.includeSpotEstimate ??= false;
    this.testRun ??= false;
  }

  setDefaults(ux: IUserExperience): void {
    switch (ux?.activeEmployee.tenantID.toUpperCase()) {
      case TenantIds.BEI:
        this.integrateExtraItems = true;
        this.includeDailyTotals = true;
        this.includeTotals = true;
        break;
      case TenantIds.ESE:
        this.integrateExtraItems = true;
        this.includeLegEstimate = true;
        this.includeSpotEstimate = true;
        this.includeExtraItems = true;
        this.includeExtraAmounts = true;
        this.includeDailyTotals = true;
        this.includeTotals = true;
        this.message =
          "<div>Please <b>review and let us know by 11:00 AM tomorrow</b> if there are any errors.</div><div>Corrections submitted after 11:00 AM will be included in next week's check.</div>";
        break;
      case TenantIds.SYCS:
        this.integrateExtraItems = true;
        this.includeDailyTotals = true;
        this.includeTotals = true;
        break;
      case TenantIds.JSSJ:
        this.includeLegEstimate = true;
        this.includeSpotEstimate = true;
        this.includeExtraItems = true;
        this.includeExtraAmounts = true;
        this.includeDailyTotals = true;
        this.includeTotals = true;
        this.integrateExtraItems = true;
        break;
      case TenantIds.Sophia:
        this.integrateExtraItems = true;
        this.includeLegEstimate = true;
        this.includeSpotEstimate = true;
        break;
      case TenantIds.T27:
        this.includeLegEstimate = true;
        this.includeSpotEstimate = true;
        this.includeExtraItems = true;
        this.includeExtraAmounts = true;
        this.includeDailyTotals = true;
        this.includeTotals = true;
        this.integrateExtraItems = true;
        break;
      default:
        this.integrateExtraItems = true;
        break;
    }
  }
}
